import React, { FC, Suspense, ReactElement } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import store from './store';
import AppRoutes from './AppRoutes';
import { configureApi } from './api/station-tools-api';
import theme from './theme';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import NotificationSnackbar from './components/NotificationSnackbar';
// if (process.env.NODE_ENV !== "production") {
//   const { whyDidYouUpdate } = require("why-did-you-update");
//   whyDidYouUpdate(React);
// }

configureApi();

// Fix for TypeScript React 17 + Redux Provider issue
// Using @ts-ignore for the Provider as this is a known issue with React 17 types
const App: FC = (): ReactElement => {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        {/* @ts-ignore - React-Redux Provider has compatibility issues with React 17 types */}
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Suspense fallback={<div />}>
                <AppRoutes />
                <NotificationSnackbar />
              </Suspense>
            </LocalizationProvider>
          </ThemeProvider>
        </Provider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
};

export default App;
